module.exports = __webpack_public_path__ + "static/ibm-plex-sans-v7-latin-italic-272f86114c980c52c131dfc3b4ae3276.woff";